import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import moment from "moment";

const UpdateUserModal = ({
  viewUpdateModal,
  setViewUpdateModal,
  selectedUser,
  handleUpdateUser,
}) => {
  const [formData, setFormData] = useState({
    id: selectedUser?.id || "",
    first_name: selectedUser?.first_name || "",
    mobile_no: selectedUser?.mobile_no || "",
    email: selectedUser?.email || "",
    created_at: selectedUser?.created_at || "",
    updated_at: selectedUser?.updated_at || "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData({
      id: selectedUser?.id || "",
      first_name: selectedUser?.first_name || "",
      last_name: selectedUser?.last_name || "",
      mobile_no: selectedUser?.mobile_no || "",
      email: selectedUser?.email || "",
      in_house_user: selectedUser?.in_house_user || 0,
    });
  }, [selectedUser]);

  const validate = () => {
    const newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = "First Name is required";
    }
    if (
      !formData.email ||
      !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)
    ) {
      newErrors.email = "Please enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    if (validate()) {
      console.log(formData,"formData")
      const formattedData = new FormData();

      // Append each field to the FormData object
      Object.keys(formData).forEach((key) => {
        formattedData.append(key, formData[key]);
      });

      // Pass the FormData to the parent component
      handleUpdateUser(formattedData);
      setViewUpdateModal(false);
    }
  };

  return (
    <Modal
      show={viewUpdateModal}
      onHide={() => setViewUpdateModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Update User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col xs={12}>
              <Form.Group controlId="formId">
                <Form.Label>ID</Form.Label>
                <Form.Control
                  type="text"
                  name="id"
                  value={formData.id}
                  readOnly
                  disabled
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group controlId="formFirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  isInvalid={!!errors.first_name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.first_name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> <Col xs={12}>
              <Form.Group controlId="formFirstName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  isInvalid={!!errors.last_name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.last_name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group controlId="formMobileNo">
                <Form.Label>Mobile No</Form.Label>
                <Form.Control
                  type="text"
                  name="mobile_no"
                  value={formData.mobile_no}
                  readOnly
                  disabled
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            {/* <Col xs={12}>
              <Form.Group controlId="formInHouseUser">
                <Form.Label>In House User</Form.Label>
                <Form.Check
                  type="checkbox"
                  name="in_house_user"
                  label="Yes"
                  checked={formData.in_house_user === 1}
                  onChange={(e) =>
                    setFormData((prevData) => ({
                      ...prevData,
                      in_house_user: e.target.checked ? 1 : 0,
                    }))
                  }
                  isInvalid={!!errors.in_house_user}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.inHouseUser}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> */}
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="secondary" style={{border:"none"}}  onClick={() => setViewUpdateModal(false)}>
          Cancel
        </Button>
        <Button style={{backgroundColor:"#e8783d",border:"none"}} onClick={handleSaveChanges}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateUserModal;
